import { createContext, useContext, useEffect, useState } from 'react';
import { api } from '../api/client';
import { clearTokens, getAccess, setTokens } from './storage';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [initializing, setInitializing] = useState(true);

  useEffect(() => {
    if (!getAccess()) {
      setInitializing(false);
      return;
    }
    api
      .get('/auth/me')
      .then((r) => setUser(r.data))
      .catch(() => clearTokens())
      .finally(() => setInitializing(false));
  }, []);

  const login = async (email, password) => {
    const res = await api.post('/auth/login', { email, password });
    setTokens(res.data.access, res.data.refresh);
    setUser(res.data.user);
  };

  const signup = async (payload) => {
    const res = await api.post('/auth/signup', payload);
    setTokens(res.data.access, res.data.refresh);
    setUser(res.data.user);
  };

  const logout = async () => {
    try {
      await api.post('/auth/logout');
    } catch (_) {
      // Fehler beim Server-Logout sind irrelevant – wir clearen lokal sowieso
    }
    clearTokens();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, initializing, login, signup, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
